import { Input } from 'components/partials/Fields/FormikInput';
import Phone from 'components/partials/Fields/FormikPhone';
import { Section } from 'components/FormikForm/Section';
import DoubleColumn from 'components/FormikForm/Section/DoubleColumn';
import { CountrySelect } from 'components/partials/Fields/FormikCountrySelect';
import Address from 'components/partials/Fields/Address';
import { AUCTION_BUYER, PRIVATE_SELLER } from 'helpers/users';

const ContactInformation = ({
    countries = [],
    regType,
    isSuspended,
    settingsPage = false,
}) => {
    const isDisabled = regType == AUCTION_BUYER.id || regType == PRIVATE_SELLER.id || isSuspended;

    return (
        <Section title="Your Contact Information" hasLayout padding>
            <DoubleColumn>
                <Input
                    formik
                    name="fname"
                    label="First Name"
                    disabled={isDisabled}
                />
                <Input
                    formik
                    name="lname"
                    label="Last Name"
                    disabled={isDisabled}
                />
                <Input
                    formik
                    label="Email"
                    name="email"
                    disabled={isDisabled}
                />
                <Input
                    formik
                    label="Confirm Email"
                    name="email_confirm"
                    disabled={isDisabled}
                />
                <Phone
                    formik
                    label="Phone"
                    name="phone"
                    disabled={isDisabled}
                />
                <CountrySelect stateField="state_id"/>
            </DoubleColumn>
            <Address
                countries={countries}
                formik
                isAuctionBuyer={regType == AUCTION_BUYER.id}
                settingsPage={settingsPage}
            />
        </Section>
    );
};

export default ContactInformation;
